module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title is-parent is-12 is-vertical"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "container is-child",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('p', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v(_vm._s(_vm.Fixture.match_date))])]), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('img', {
    staticClass: "team_logo",
    attrs: {
      "src": _vm.Fixture.home_team.logo
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "subtitle has-text-left"
  }, [_vm._v(_vm._s(_vm.Fixture.home_team.name) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('img', {
    staticClass: "team_logo",
    attrs: {
      "src": _vm.Fixture.away_team.logo
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "subtitle has-text-left"
  }, [_vm._v(_vm._s(_vm.Fixture.away_team.name))])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('p', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v(_vm._s(_vm.Fixture.competition))]), _vm._v(" "), _c('p', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v(_vm._s(_vm.Fixture.location))])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23583e95"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/EditTable/box-score.vue
// module id = 599
// module chunks = 30